var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRemindersPending(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 77.539 78.803",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_16636",
    "data-name": "Group 16636",
    transform: "translate(-1 -1.011)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32214",
    "data-name": "Path 32214",
    d: "M59.929,61.463A35.745,35.745,0,0,1,54.6,51.305a2.585,2.585,0,0,0-4.911,1.6,39.208,39.208,0,0,0,3.386,7.521H8.392a41.147,41.147,0,0,0,5.531-20.677V33.29A16.7,16.7,0,0,1,26.846,17.007a15.921,15.921,0,0,1,3.877-.517h.336a2.6,2.6,0,0,0,.62-5.169,14.4,14.4,0,0,0-4.471.233,4.135,4.135,0,0,1-.362-1.525,3.877,3.877,0,0,1,3.877-3.877,3.929,3.929,0,0,1,3.1,1.551,2.585,2.585,0,1,0,4.135-3.05,9.02,9.02,0,0,0-15.74,8.4A21.866,21.866,0,0,0,8.754,33.29v6.462A35.952,35.952,0,0,1,1.517,61.463,2.585,2.585,0,0,0,3.585,65.6H16.508a14.215,14.215,0,1,0,28.431,0H57.862a2.59,2.59,0,0,0,2.068-4.135ZM30.723,73.352A9.046,9.046,0,0,1,21.806,65.6H39.769a9.046,9.046,0,0,1-9.046,7.754Z",
    transform: "translate(0 0)",
    fill: "#ff0185"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32215",
    "data-name": "Path 32215",
    d: "M35.677,2A20.677,20.677,0,1,0,56.354,22.677,20.677,20.677,0,0,0,35.677,2Zm3.231,31.015H32.446a2.585,2.585,0,0,1,0-5.169h.646V18.722a2.585,2.585,0,0,1-1.6-4.911l3.231-1.292a2.583,2.583,0,0,1,3.541,2.4V27.846h.646a2.585,2.585,0,1,1,0,5.169Z",
    transform: "translate(22.185 1.567)",
    fill: "#96006b"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemindersPending);
export default __webpack_public_path__ + "static/media/RemindersPending.f3062f3ed017842e85dfa07a879154bb.svg";
export { ForwardRef as ReactComponent };